/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VendorAttributeTypes = 'Requirement' | 'Question' | 'Optional' | 'Information';

export const VendorAttributeTypes = {
    Requirement: 'Requirement' as VendorAttributeTypes,
    Question: 'Question' as VendorAttributeTypes,
    Optional: 'Optional' as VendorAttributeTypes,
    Information: 'Information' as VendorAttributeTypes
};

